import { styled, Box as MuiBox, Stack as MuiStack } from "@mui/material";

export const Box = styled(MuiBox)(
  ({ theme }) => `
  &.modal-container {
    min-width: 382px;
    color: ${theme.palette.grey[700]};
  }
  
  &.certificate-view-container {
    display: flex;
    flex-direction: row;
    gap: 30px;
    min-height: 92px;
    padding: 8px 10px;
    font-size: 12px;

    .certificate-name {
      max-width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
    }
    .expiration-date {
      max-width: 240px;
      display: flex;

      .label {
        width: 34px;
        margin-right: 10px;
        white-space: nowrap;
      }
      .date {
        max-width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .red {
    color: ${theme.palette.alert};
  }
  &.badge {
    border-radius: 2px;
    padding: 0 4px;
    color: white;
    font-size: 11px;  
    &.red {
      background-color: ${theme.palette.alert};
    }
  }
`
);

export const Stack = styled(MuiStack)(() => ``);
